module.exports = __webpack_public_path__ + "../../static/img/mcpixel.26f46e38.png";